import VideoViewWeb from "./VideoViewWeb";
export default VideoViewWeb;
